module.exports = __webpack_public_path__ + "static/img_oneoff_01@2x-aea85fbaf332d0190bfc93d0548a1c7a.png";